import { Component, Input, Output, EventEmitter, OnInit, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationItem, NotificationType } from '@data/schema/notificationitem';
import { AsperaWebService } from '@gah-core/services/aspera-web.service';
import { AuthenticationService } from '@gah-core/services/authentication.service';
import { NotificationService } from '@gah-core/services/notification.service';
import { SessionStorageService } from '@gah-core/services/session-storage.service';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { DigitalCartService } from '@modules/assets/services/digital-cart.service';
import { CartCheckoutService } from '@modules/user/services/cart-checkout.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import JSZip from 'jszip';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { NGXLogger } from 'ngx-logger';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { GahMatDialogComponent } from '@shared/components/gah-mat-dialog/gah-mat-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewportScroller } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { GoogleanalyticsmoduleserviceService } from '@shared/services/googleanalyticsmoduleservice.service';

@Component({
  selector: 'app-asset-cart-checkout-download-popup',
  templateUrl: './asset-cart-checkout-download-popup.html',
  styleUrls: ['./asset-cart-checkout-download-popup.scss'],
})
export class AssetCartCheckoutDownloadPopupComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  isLoading: boolean = false;
  @Input() runnerId: string[];
  @Input() downloadFileName: string[];
  @Input() downloadFileData = [];
  downloadUrls: string[] = [];
  getRequests = [];
  emailedRunnerAssetReleaseIds: number[] = [];
  _http: HttpClient;
  @Input() assetRunnerId: number;
  assetData = [];

  //GAHR-738
  @Input() downloadPopupVisible: boolean = true;
  @Output() downloadPopupVisibleChange = new EventEmitter<boolean>();
  @Input() tokenId: string;

  downloadInProgress: boolean = false;
  @Input() assetDownloadType: string = null;
  @Input() assetProxyType: string = null;
  selected: string = 'Standard';
  hoverPopup: boolean = false;
  downloadMethod = [
    {
      key: 'Standard',
      checked: true,
    },
    {
      key: 'Aspera',
      checked: false,
    },
  ];

  proxyArrayList = [
    {
      resolution: 'High Resolution',
      id: 'proxyHighResId',
      checked: true,
      disabled: false,
    },
    {
      resolution: 'Standard Resolution',
      id: 'proxyStandardResId',
      checked: false,
      disabled: false,
    },
  ];

  @Input() assetLength: number;
  @Input() sharePermission: string;

  constructor(
    private notificationService: NotificationService,
    private asperaWebService: AsperaWebService,
    private log: NGXLogger,
    private translate: TranslateService,
    private scroller: ViewportScroller,
    private handler: HttpBackend,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AssetCartCheckoutDownloadPopupComponent>,
    private googleanalyticsmoduleserviceService: GoogleanalyticsmoduleserviceService
  ) {
    this._http = new HttpClient(handler);
    this.downloadFileData = data.selectedAssets;
    this.assetLength = data.assetCounts;
  }

  ngOnInit() {
    if (this.sharePermission === 'POD') {
      this.assetProxyType = 'Standard Resolution';
      this.proxyArrayList = [
        {
          resolution: 'High Resolution',
          id: 'proxyHighResId',
          checked: false,
          disabled: true,
        },
        {
          resolution: 'Standard Resolution',
          id: 'proxyStandardResId',
          checked: true,
          disabled: false,
        },
      ];
    }
    this.runnerId = [];
    this.downloadFileName = [];
    let temp = this.downloadFileData;
    this.assetData = this.downloadFileData;
    this.downloadFileData = [];
    temp.forEach(element => {
      if(element?.is_selected == true){
        this.runnerId.push(element.runner_id);
        this.downloadFileData.push({ 'name': element.file_name, 'id': element.runner_id });
      }
    })
  }

  private createGetRequets(data: string[]) {
    this.getRequests = [];
    data.forEach((url) => this.getRequests.push(this._http.get(url, { responseType: 'blob' })));
  }
  downloadHttpUrls() {
    let date = new Date();
    let dateDownload: string =
      date.getFullYear().toString() +
      '-' +
      date.getMonth().toString() +
      '-' +
      date.getDate().toString();

    let timeDownload: string = date.getHours().toString() + '-' + date.getMinutes().toString();

    let name = 'bulk_file_download_' + dateDownload + '_' + timeDownload + '.zip';

    this.createGetRequets(this.downloadUrls);

    // forkJoin(this.getRequests)
    forkJoin(this.getRequests).subscribe((res) => {
      this.log.log('Http Download started');
      const zip = new JSZip();

      res.forEach((f, i) => {
        zip.file(this.downloadFileName[i], f);
      });

      zip.generateAsync({ type: 'blob' }).then((blob) => {
        const a: any = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      });
      this.isLoading = false;
    });
  }

  downloadAssetBasedOnProxySelection() {
    this.downloadFileData;
    this.isLoading = true;
    this.assetProxyType == null ? this.assetProxyType = 'original' : '';
    if (this.assetDownloadType === 'Standard' || this.selected === 'Standard') {
      this.googleanalyticsmoduleserviceService.sendDataToAnalyticsOnBulkDownloadCart(this.assetData, 'Standard', this.assetProxyType);
      this.downloadUrls = [];
      this.asperaWebService
        .httpRunnerDownloadFiles(this.runnerId, this.assetProxyType)
        .subscribe((res) => {
          this.isLoading = false;
          this.downloadPopupVisible = false;
          res.serviceResult.urls.forEach((element) => {
            this.downloadUrls.push(element.url);
            for (let a of this.downloadFileData) {
              if (a.id == element.asset_item_id) {
                this.downloadFileName.push(a.name);
                break;
              }
            }
          });
          if (this.downloadUrls.length != this.downloadFileName.length) {
            this.scroller.scrollToPosition([0, 0]);
            this.notificationService.showNotification({
              message: this.translate.instant('unknown-error-msg-text'),
              messageType: NotificationType.Error,
              acrossRoutes: false,
            });
          } else {
            this.downloadHttpUrls();
          }
        });
    } else {
      this.asperaWebService.initAsperaConnect();
      this.asperaWebService
        .asperaRunnerDownloadFiles(this.runnerId, this.assetProxyType)
        .subscribe((downloadItems) => {
          this.log.log('Aspera Download started', downloadItems);
          this.downloadPopupVisible = false;
          this.isLoading = false;
        });
        this.googleanalyticsmoduleserviceService.sendDataToAnalyticsOnBulkDownloadCart(this.assetData, 'Aspera', this.assetProxyType);
    }
  }

  hideDownloadPopup() {
    this.downloadPopupVisibleChange.emit((this.downloadPopupVisible = false));
    this.resetPopup();
    this.dialogRef.close();
  }

  setProxyVal(event) {
    this.assetProxyType = event.value;
  }

  setDownloadTypeVal(event) {
    this.assetDownloadType = event.value;
  }

  hidePopover() {
    this.hoverPopup = false;
  }

  showPopover() {
    this.hoverPopup = true;
  }

  popupHiding(e) {
    this.downloadPopupVisibleChange.emit((this.downloadPopupVisible = false));
    this.resetPopup();
    this.dialogRef.close();
  }

  resetPopup() {
    this.assetProxyType = 'original';
    this.assetDownloadType = 'Standard';
    this.selected = 'Standard';
  }
}
